/* eslint-disable no-throw-literal */
export default (error) => {
  if (process.env.REACT_APP_ProfileID === 'cg002-pro1') {
    console.log('error')
  } else {
    console.log('error', error)
  }
  throw 'error'
}
